import { BaseController } from "./_BaseController";
import { TypedMatNode } from "../_Base";
import { NodeParamsConfig, ParamConfig } from "../../utils/params/ParamsConfig";
import { isBooleanTrue } from "../../../../core/BooleanValue";
import { ColorConversion } from "../../../../core/Color";
import { MeshBasicMaterial } from "three";
export function ColorParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.color = ParamConfig.COLOR([1, 1, 1], {
        conversion: ColorConversion.SRGB_TO_LINEAR
      });
      this.useVertexColors = ParamConfig.BOOLEAN(0, { separatorAfter: true });
      this.transparent = ParamConfig.BOOLEAN(0);
      this.opacity = ParamConfig.FLOAT(1);
      this.alphaTest = ParamConfig.FLOAT(0);
    }
  };
}
class ColorParamsConfig extends ColorParamConfig(NodeParamsConfig) {
}
class ColoredMatNode extends TypedMatNode {
  createMaterial() {
    return new MeshBasicMaterial();
  }
}
export class ColorsController extends BaseController {
  constructor(node) {
    super(node);
    this.node = node;
  }
  static update(node) {
    const material = node.material;
    const pv = node.pv;
    material.color.copy(pv.color);
    const newVertexColor = isBooleanTrue(pv.useVertexColors);
    if (newVertexColor != material.vertexColors) {
      material.vertexColors = newVertexColor;
      material.needsUpdate = true;
    }
    material.opacity = pv.opacity;
    material.transparent = pv.transparent;
    material.alphaTest = pv.alphaTest;
  }
}
